import * as angular from 'angular';
import { NetworkPointResource } from 'app/_resources/network-point.resource';

class NetworkPointDetailsOperatorSpecificConditionsComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public conditionsExpanded: boolean = true;
    public networkPoint: NetworkPointDto;
    public specificConditions: SpecificConditionDto;

    constructor(
        private NetworkPoint: NetworkPointResource,
        private $scope: angular.IScope
    ) {}

    $onInit(): void {
        this.$scope.$watch(
            () => this.networkPoint.ownerTso0,
            (newValue, oldValue) => {
                if (newValue === '') {
                    this.networkPoint.ownerTso0 = null;
                    this.networkPoint.ownerTerms0 = null;
                }
            }
        );
        this.loadSpecificConditions();
    }

    private loadSpecificConditions() {
        this.NetworkPoint.getSpecificConditions(
            { id: this.networkPoint.id0 },
            (result: SpecificConditionDto) => {
                this.specificConditions = result;
            }
        );
    }
}

angular
    .module('app')
    .component('pkpNetworkPointDetailsOperatorSpecificConditions', {
        controller: NetworkPointDetailsOperatorSpecificConditionsComponentCtrl,
        template:
            require('app/network-point/network-point-details-operator-specific-conditions.component.html'),
        bindings: {
            form: '=',
            networkPoint: '=',
            isEditMode: '<',
            isCreateMode: '<'
        }
    });
